import type { FC } from 'react';

import { SITE } from '@/constants/site.constants';
import { SECTION_IDS } from '@/features/home/constants/home.constants';
import type { HeroStat } from '@/types/home.types';

interface HeroSectionProps {
  stats: HeroStat[];
}

const HeroSection: FC<HeroSectionProps> = ({ stats }) => (
  <section className="relative overflow-hidden bg-gradient-to-b from-brand-50 via-white to-white">
    {/* Soft brand wash behind the headline — decorative only. */}
    <div
      aria-hidden
      className="pointer-events-none absolute -top-40 left-1/2 h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-brand-100/70 blur-3xl"
    />

    <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center gap-8 px-5 py-20 text-center md:px-8 md:py-28">
      <span className="inline-flex items-center gap-2 rounded-full border border-brand-100 bg-white px-4 py-1.5 text-xs font-semibold tracking-wide text-brand-700 uppercase">
        Campus-only rentals
      </span>

      <h1 className="max-w-3xl font-display text-4xl leading-[1.08] font-extrabold text-[var(--color-ink)] md:text-6xl">
        {SITE.tagline}
      </h1>

      <p className="max-w-2xl text-base leading-relaxed text-[var(--color-ink-muted)] md:text-lg">
        {SITE.intro}
      </p>

      <div className="flex flex-col gap-3 sm:flex-row">
        {/* <a
          href={`#${SECTION_IDS.download}`}
          className="inline-flex h-12 items-center justify-center rounded-full bg-brand-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-brand-700"
        >
          Get the app
        </a> */}
        <a
          href={`#${SECTION_IDS.howItWorks}`}
          className="inline-flex h-12 items-center justify-center rounded-full border border-[var(--color-divider)] bg-white px-7 text-sm font-semibold text-[var(--color-ink)] transition-colors hover:bg-[var(--color-surface-muted)]"
        >
          See how it works
        </a>
      </div>

      <dl className="mt-6 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="rounded-2xl border border-[var(--color-divider)] bg-white px-5 py-5 shadow-[var(--shadow-card)]"
          >
            <dt className="font-display text-lg font-bold text-[var(--color-ink)]">{stat.value}</dt>
            <dd className="mt-1 text-sm text-[var(--color-ink-muted)]">{stat.label}</dd>
          </div>
        ))}
      </dl>
    </div>
  </section>
);

export default HeroSection;
